module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (16).f6c2e9b8.jpg";